import { useState } from "react";

type AvatarRole = "dm" | "pm" | "vp" | "ccm" | "spm" | "ops";

interface AvatarProps {
  name: string;
  imageUrl?: string;
  role?: AvatarRole;
  size?: "sm" | "lg";
  className?: string;
}

function getInitials(name: string): string {
  // Strip anything in parentheses e.g. "(Corp)", then split on whitespace/comma
  const cleaned = name
    .replace(/\(.*?\)/g, "")   // remove (Corp), (Jr), etc.
    .replace(/,/g, "")          // remove commas from "Last, First" format
    .trim()
    .split(/\s+/)
    .filter(w => /^[a-zA-Z]/.test(w));  // only words starting with a letter

  if (cleaned.length === 0) return "?";
  if (cleaned.length === 1) return cleaned[0].slice(0, 2).toUpperCase();

  // First word initial + last word initial
  return (cleaned[0][0] + cleaned[cleaned.length - 1][0]).toUpperCase();
}

export function Avatar({ name, imageUrl, role, size = "sm", className = "" }: AvatarProps) {
  const [imgFailed, setImgFailed] = useState(false);
  const initials = getInitials(name);

  const sizeClass = size === "lg" ? "qba-avatar qba-avatar--lg" : "qba-avatar";
  const roleClass = role ? `qba-avatar--${role}` : "qba-avatar--dm"; // fallback so it always has a color

  return (
    <div className={`${sizeClass} ${roleClass} ${className}`.trim()}>
      {imageUrl && !imgFailed ? (
        <img
          src={imageUrl}
          alt={name}
          onError={() => setImgFailed(true)}
        />
      ) : (
        initials
      )}
    </div>
  );
}